import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.originalContentNode = this.element.firstChild.cloneNode(true)

    // Create content to display on clicking button
    var img = document.createElement("img")
    img.src = "https://www.asc.ohio-state.edu/orban.14/stemcoding/check_mark.png"
    img.height = 15
    img.width = 15

    var message = navigator.platform.startsWith("Mac") || navigator.platform === "iPhone" || navigator.platform === "iPad"
      ? " Code copied to clipboard.\nPaste into the editor using CMD + V."
      : " Code copied to clipboard.\nPaste into the editor using CTRL + V."
    
    this.messageNode = document.createElement("div")
    this.messageNode.appendChild(img)
    this.messageNode.append(message)

    // Prevent users from spamming button
    this.ready = true
  }

  feedback() {
    navigator.clipboard.writeText(this.element.getAttribute("data-clipboard-text"))

    if (this.ready) {
      this.ready = false

      // Overwrite original content
      this.element.replaceChild(this.messageNode, this.element.firstChild)

      // Restore original content after 5 seconds
      setTimeout(() => {
          this.element.replaceChild(this.originalContentNode, this.element.firstChild)

          this.ready = true
        }, 5000
      )
    }
  }
}
